






import { defineComponent } from '@vue/composition-api';
import iconImage from '@/assets/images/icon-64x64.png';

export default defineComponent({
  name: 'LogoImage',

  setup() {
    return { iconImage };
  },
});
